import React, { useEffect, useState } from 'react';
import './ThemeSwitcher.css';

/**
 * Development-only theme picker.
 *
 * The active palette is chosen by the data-theme attribute in index.html, so
 * shipping more than one theme means editing a file and reloading. This puts
 * the same switch in the browser during development: pick a theme, it applies
 * immediately and the choice is remembered for the rest of the session.
 *
 * The guard is import.meta.env.DEV, which Vite replaces at build time, so the
 * production bundle never contains this component or its styles.
 */

// Kept in step with the [data-theme] blocks in theme.css.
const THEMES = ['orange', 'purple', 'terracotta'];

const ThemeSwitcher = () => {
  const [theme, setTheme] = useState(() => document.documentElement.dataset.theme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  if (!import.meta.env.DEV) return null;

  return (
    <div className="theme-switcher">
      <label className="theme-switcher__label" htmlFor="theme-switcher-select">
        Theme
      </label>
      <select
        id="theme-switcher-select"
        className="theme-switcher__select"
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
      >
        {THEMES.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ThemeSwitcher;